module.exports = __webpack_public_path__ + "static/media/food1234.e0bbbe89.jpg";